export const COLOR_MAIN = '#394151';
export const COLOR_EMPOWERMENT_GREEN = '#2DD28D';
export const COLOR_EMPOWERMENT_GREEN_AA = '#1B7E55';

export const COLOR_TEXT_MAIN = '#4C566C';
export const COLOR_MAIN_BACKGROUND = '#BF4140';
export const COLOR_TEXT_SECONDARY = '#2DCC70';
export const COLOR_TEXT_SUBTITLE = '#8E8E93';
export const COLOR_BUTTON_TEXT = '#FFFFFF';
export const COLOR_BUTTON_BACKGROUND = '#FFFFFF';
export const COLOR_HOVER = '#687082';
export const COLOR_TEXT_DISABLE = 'rgba(75, 85, 106, 0.24)';
export const COLOR_BACKGROUND_DISABLE = '#E6E7E8';
export const COLOR_RED = '#BF4140';
export const COLOR_BORDER = '#E6E7E8';
export const COLOR_EFFECT = '#707889';

export const COLOR_TEXT_LINK = '#006BD6';
export const COLOR_WARNING = '#BF4140';
export const COLOR_SHADOW = 'rgba(0, 0, 0, 0.04)';
//export const COLOR_TEXT_LINK_AA = '#1B7E55';

export const COLOR_MENU_BACKGROUND = '#FFFFFF';
export const COLOR_MENU_HEADER = '#F2F4F5';

export const COLOR_CONTENT_BACKGROUND = '#FFFFFF';
export const COLOR_SIDEMENU_BACKGROUND = '#FFFFFF';
export const COLOR_SECONDARY_BACKGROUND = '#F5F6F7';
export const COLOR_DISABLE_BACKGROUND = '#E6E7E8';
